import { factoryService, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_BUYER_URL } from '../config/settings/environment'

/**
 * This function registers an error during the flow process for a user by making an API request.
 * It logs the error details, including the specific step, message, and type of validation error.
 */
export const registerError = factoryService(({ flowId, origin, message, type }) => {
  const body = {
    idFlujo: flowId,
    origen: origin,
    mensaje: message,
    tipo: type
  }

  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/registrarError`, { body })
})
